<template>
  <div class="audit-page">
    <audit-info :status="status"></audit-info>
    <audit-table v-if="status === 2" :status="status"></audit-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AuditInfo from './audit/AuditInfo.vue'
import AuditTable from './audit/AuditTable.vue'

export default {
  components: {
    AuditInfo,
    AuditTable
  },
  computed: {
    ...mapState({
      status: (state) => {
        if (state.enterState === 'CHECKING') return 1
        else if (state.enterState === 'NEED_MODIFY') return 2
        else return 0
      }
    })
  }
}
</script>
